import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { AuthService } from "@front/m19-services";
import { IButtonDirective, IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { LogoComponent } from "@m19-board/shared/logo/logo.component";

@Component({
  selector: "app-onboarding-layout",
  templateUrl: "./onboarding-layout.component.html",
  imports: [RouterOutlet, LogoComponent, IButtonDirective, ITooltipDirective, TranslocoDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingLayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  logout() {
    this.authService.logout(true);
  }
}
